var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5779 2.63281H25.3826V21.9885H14.5779V2.63281Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2639 12.3111C15.2639 8.37841 17.1161 4.89021 19.963 2.63313C17.8708 0.991688 15.2297 0 12.3484 0C5.52234 0 0 5.50569 0 12.3111C0 19.1163 5.52234 24.6221 12.3483 24.6221C15.2295 24.6221 17.8706 23.6304 19.963 21.9888C17.1161 19.766 15.2639 16.2437 15.2639 12.3111Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9603 12.3111C39.9603 19.1163 34.4379 24.6221 27.612 24.6221C24.7308 24.6221 22.0897 23.6304 19.9973 21.9888C22.8786 19.7319 24.6965 16.2437 24.6965 12.3111C24.6965 8.37841 22.8442 4.89021 19.9973 2.63313C22.0895 0.991688 24.7308 0 27.612 0C34.4379 0 39.9604 5.53997 39.9604 12.3111H39.9603Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterLogo);
export default __webpack_public_path__ + "static/media/masterLogo.6b9c9e8d39cc50b77c4b6b568e3648dc.svg";
export { ForwardRef as ReactComponent };